<template>
  <div>
    <div class = "footer">
      <div class="footer-text">服务内容&nbsp&nbsp|&nbsp&nbsp关于我们&nbsp&nbsp|&nbsp&nbsp联系我们</div>
      <div class="footer-text">Copyright2019 © 宁波市探趣互动科技有限公司 </div>
      <div class="footer-text">
        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
           style='text-decoration:none;color: #929292;'>
          <span>浙ICP备19017835号-1</span>&nbsp&nbsp
          <img style="margin-bottom: -2px" src="../../assets/imgs/beian.png">
          <span>浙公网安备 33022502000240号</span></a>
      </div>
<!--      <div class="footer-text">技术支持: 宁波市探趣互动科技有限公司</div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "HomeFooter"
  }
</script>

<style lang="stylus" scoped>
  .info
    margin 20px auto 0 auto
    width: 1100px;
    height: 60px;
    border-top solid 1px #bbb
    border-bottom solid 1px #bbb
    font-size 15px
    color #4b4b4b
    display flex
    justify-content center
    align-items center
    .info-font
      margin 0 20px 0 20px
  .footer
    width: 100%;
    height:120px;
    margin: auto;
    padding: 20px;
    .footer-text
      line-height 30px
      font-size 13px
      color #929292
</style>
